import { useBroadcastHistory } from "../hooks/use-broadcast";
import { BroadcastRecord } from "../services/broadcast";
import { summariseAudience } from "../utils/summarise-audience";

const STATUS_STYLES: Record<BroadcastRecord["status"], string> = {
  SENT: "bg-green-100 text-green-700",
  PARTIAL: "bg-amber-100 text-amber-700",
  FAILED: "bg-red-100 text-red-700",
};

export function BroadcastHistory() {
  const { data, isLoading } = useBroadcastHistory();

  if (isLoading)
    return <p className="text-sm text-gray-400">Loading…</p>;
  if (!data || data.length === 0)
    return <p className="text-sm text-gray-400">No broadcasts sent yet.</p>;

  return (
    <section className="rounded-lg border border-gray-200 bg-white p-5">
      <h2 className="mb-4 text-sm font-semibold text-gray-800">
        Recent broadcasts
      </h2>
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-gray-100 text-xs uppercase tracking-wide text-gray-400">
              <th className="pb-2 pr-4 font-medium">Title</th>
              <th className="pb-2 pr-4 font-medium">Audience</th>
              <th className="pb-2 pr-4 font-medium">Matched</th>
              <th className="pb-2 pr-4 font-medium">Status</th>
              <th className="pb-2 font-medium">Sent</th>
            </tr>
          </thead>
          <tbody>
            {data.map((b) => (
              <tr key={b.id} className="border-b border-gray-50">
                <td className="py-2 pr-4 font-medium text-gray-800">
                  {b.title}
                </td>
                <td className="max-w-[240px] truncate py-2 pr-4 text-gray-500">
                  {summariseAudience(b.filters)}
                </td>
                <td className="py-2 pr-4 text-gray-700">
                  {b.matched_count.toLocaleString()}
                </td>
                <td className="py-2 pr-4">
                  <span
                    className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${STATUS_STYLES[b.status]}`}
                  >
                    {b.status}
                  </span>
                </td>
                <td className="py-2 text-gray-500">
                  {new Date(b.created_at).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
